import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import Modal from '@mui/material/Modal';
import ReactDOM from 'react-dom';
import BillPrint from '../salereturn/Bill';

const SaleReturnCreate = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL    
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, token, logout, branchstate } = useAuth();
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedItemOption, setSelectedItemOption] = useState(null);
    const handleInputChange = (newValue) => newValue;
    const handleItemChange = (newValue) => newValue;
    const [selectedBank, setSelectedBank] = useState("");
    const [dropdownBankOptions, setDropdownBankOptions] = useState([]);
    const branchId = 0;
    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 1) {
            return [];
        }

        try {
            const response = await fetchData('SaleApi', `/Party/${companyId}/${branchId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setSupplierOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const fetchItemOptions = async (inputValue) => {
        // Early return if input value length is less than or equal to 2
        if (inputValue.length <= 1) {
            return [];
        }

        try {
            // Fetch data from the API
            const response = await fetchData('SaleReturnApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    setItemOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            CustomerId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedOption) return;

        const selectedItemId = selectedOption.value;
        const selectedSupplierRetail = supplierOptions.find((itemDetail) => itemDetail.Id === selectedItemId);
        const suppliergstno = selectedSupplierRetail?.GSTNo ?? '';
        const supplieraddress1 = (selectedSupplierRetail?.AddressLine1 ?? '');
        const supplieraddress2 = (selectedSupplierRetail?.AddressLine2 ?? '');
        const suppliercontactno = selectedSupplierRetail?.ContactNumber1 ?? '';
        const supplierlocation = selectedSupplierRetail?.Location ?? '';
        const supplierpincode = selectedSupplierRetail?.PinCode ?? '';
        const supplierName = selectedSupplierRetail?.Name ?? '';

        let newInvoiceTypeId;
        if (!suppliergstno) {
            newInvoiceTypeId = 2; // Default invoice type id for 'B To C'
            setSelectedInvoiceType({
                value: 2,
                label: 'B To C'
            });
        } else {
            const gstNumberPrefix = suppliergstno.substring(0, 2);

            if (gstNumberPrefix !== branchstate) {
                newInvoiceTypeId = 3; // Default invoice type id for 'IGST'
                setSelectedInvoiceType({
                    value: 3,
                    label: 'IGST'
                });
            } else {
                newInvoiceTypeId = 1; // Default invoice type id for 'B To B'
                setSelectedInvoiceType({
                    value: 1,
                    label: 'B To B'
                });
            }
        }

        setFormData(prevData => ({
            ...prevData,
            InvoiceTypeId: newInvoiceTypeId,
            CreatedBy: userId,
            GSTNumber: suppliergstno,
            CustomerAddress: supplieraddress1 + ' ' + supplieraddress2,
            ContactNumber: suppliercontactno,
            CustomerName: supplierName,
            ShipTo: supplierName,
            ShipGSTNo: suppliergstno,
            ShipToAddress1: supplieraddress1,
            ShipToAddress2: supplieraddress2,
            ShipToPincode: supplierpincode,
            ShipToLocation: supplierlocation,
        }));

        fetchmaxbillno(newInvoiceTypeId);
    };

    const fetchmaxbillno = (invtype) => {
        fetchData('SaleReturnApi', `/MaxBillno/${companyId}/${branchId}/${invtype}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setFormData(prevData => ({
                    ...prevData,
                    BillNumber: data.BillNumber,
                    BillPrefix: data.BillPrefix,
                    FinYear: data.FinYear,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Max Billno', error);
            });
    };

    const handleChangeDrop = (selectedOption) => {
        setSelectedItemOption(selectedOption);

        const selectedItemId = selectedOption ? selectedOption.value : '';
        const selectedItemDetail = itemOptions.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            const quantity = parseFloat(modalData.Quantity) || 0;
            const packetquantity = parseFloat(modalData.QuantityInPackets) || 0;
            const rate = ''; //parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
            const cgstrate = parseFloat(selectedItemDetail.CGSTRate.toFixed(2)) || 0;
            const sgstrate = parseFloat(selectedItemDetail.CGSTRate.toFixed(2)) || 0;
            const cessrate = parseFloat(selectedItemDetail.CESSRate.toFixed(2)) || 0;
            let gstrate = (cgstrate + sgstrate).toFixed(2);
            const amount = (quantity * (rate / (1 + gstrate / 100))).toFixed(2);
            let Discper = 0;
            let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
            let totdiscount = parseFloat(Addidiscamt);
            let grate = (rate - totdiscount).toFixed(2);
            let salerate = (grate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            let cessamt = 0;

            if (formData.InvoiceTypeId == 3) {
                igstamt = ((taxableamount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((taxableamount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((taxableamount * (sgstrate)) / 100).toFixed(2);
            }
            cessamt = ((taxableamount * (cessrate)) / 100).toFixed(2);
            let gstamt = parseFloat((cgstamt + sgstamt + igstamt)).toFixed(2);
            const totalAmount = (parseFloat(taxableamount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt) + parseAndFix(cessamt)).toFixed(2);

            setModalData({
                ...modalData,
                Rate: rate,//selectedItemDetail.MRP.toFixed(2), // Assuming Rate is a number
                GSTRate: gstrate,
                CESSRate: cessrate,
                CESSAmount: cessamt,
                ItemName: selectedOption ? selectedItemDetail.ItemName : '',
                ItemName1: selectedOption ? selectedItemDetail.ItemName1 : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                DiscountPercentage: Discper,
                DiscountAmount: totdiscount * quantity,
                TaxableAmount: taxableamount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
                QuantityStock: selectedItemDetail.QuantityStock,
                PacketStock: selectedItemDetail.PacketStock,
                Noofpktinacase: selectedItemDetail.Noofpktinacase,
                HSNCode: selectedItemDetail.HSNCode,

            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '',
                GSTRate: '0.00',
                ItemName1: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: '0.00',
                DiscountPercentage: '0.00',
                DiscountAmount: '0.00',
                TaxableAmount: '0.00',
                CGSTAmount: '0.00',
                SGSTAmount: '0.00',
                IGSTAmount: '0.00',
                TotalAmount: '0.00',
                GSTAmt: '0.00',
                QuantityStock: 0,
                PacketStock: 0,
                Noofpktinacase: 0,
                HSNCode: '',

            });
        }
    };
    
    useEffect(() => {
        fetchInvoicetypeData();
        fetchBrancheData();
    }, []);


    //FOR GET Customer  Details FROM API  
    const [selectedInvoiceType, setSelectedInvoiceType] = useState("");
    const [dropdownInvoiceTypeOptions, setDropdownInvoiceTypeOptions] = useState([]);

    const [dropdownBranchOptions, setDropdownBranchOptions] = useState([]);

    //FOR GET BranchData  Details FROM API
    const fetchBrancheData = () => {
        fetchData('SaleReturnApi', `/Branch/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownBranchOptions(data);

                // Find the specific record you need
                const specificRecord = data.find(record => record.Id === Number(branchId));

                if (specificRecord) {
                    setFormData((prevData) => ({
                        ...prevData,
                        DispatchFrom: specificRecord.CompanyName,
                        DispatchAddress1: specificRecord.AddressLine,
                        DispatchLocation: specificRecord.Location,
                        DispatchPincode: specificRecord.PinCode,

                        TransporterName: specificRecord.CompanyName,
                        TransporterGST: specificRecord.GSTNumber,

                        CreatedBy: userId,
                    }));
                } else {
                    console.error('Specific record not found');
                }
            })
            .catch((error) => {
                console.error('Error fetching Branch dropdown options:', error);
            });
    };

    //FOR GET InvoicetypeData  Details FROM API
    const fetchInvoicetypeData = () => {
        fetchData('PurchaseApi', `/InvoiceType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownInvoiceTypeOptions(data);

                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                setFormData(prevData => ({
                    ...prevData,
                    BillDate: formattedDate,
                    BranchId: branchId,
                    CompanyId: companyId,
                    CreatedBy: userId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    // const [formData, setFormData] = useState([]);
    const [formData, setFormData] = useState({
        PaidAmount: 0,
        BalanceAmount: 0,
    });
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    const parseAndFix = (val) => parseFloat(val) || 0;

    const calculateItemData = (item, formData) => {
        let rate = parseAndFix(item.Rate);
        let quantity = '';
        let qty = parseAndFix(item.Quantity);
        let quantityInPackets = parseAndFix(item.QuantityInPackets);
        quantity = quantityInPackets > 0 ? quantityInPackets : qty;

        let cgstrate = parseAndFix(item.GSTRate / 2);
        let sgstrate = parseAndFix(item.GSTRate / 2);
        let cessrate = parseAndFix(item.CESSRate);
        let gstrate = (cgstrate + sgstrate).toFixed(2);
        let amount = (quantity * (rate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100))).toFixed(2);
        let Discper = parseAndFix(item.DiscountPercentage);
        let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
        let totdiscount = parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);
        let salerate = (grate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100)).toFixed(2);
        const taxableamount = (quantity * salerate).toFixed(2);
        let cgstamt = 0;
        let sgstamt = 0;
        let igstamt = 0;


        if (formData.InvoiceTypeId == 3) {
            igstamt = ((taxableamount * (cgstrate + sgstrate)) / 100).toFixed(2);
        } else {
            cgstamt = ((taxableamount * cgstrate) / 100).toFixed(2);
            sgstamt = ((taxableamount * sgstrate) / 100).toFixed(2);
        }
        let cessamt = ((taxableamount * (cessrate)) / 100).toFixed(2);
        let gstamt = (parseAndFix(cgstamt) + parseAndFix(sgstamt) + parseAndFix(igstamt)).toFixed(2);
        let totalAmount = (parseAndFix(taxableamount) + parseAndFix(cgstamt) + parseAndFix(sgstamt) + parseAndFix(igstamt) + parseAndFix(cessamt)).toFixed(2);

        return {
            ...item,
            CESSRate: cessrate,
            CESSAmount: cessamt,
            Amount: amount,
            TaxableAmount: taxableamount,
            CGSTAmount: parseAndFix(cgstamt).toFixed(2),
            SGSTAmount: parseAndFix(sgstamt).toFixed(2),
            IGSTAmount: parseAndFix(igstamt).toFixed(2),
            TotalAmount: parseAndFix(totalAmount).toFixed(2),
            DiscountAmount: parseAndFix(totdiscount * quantity).toFixed(2),
        };
    };


    // Utility function to calculate totals
    const calculateTotals = (updatedItemData) => {
        return updatedItemData.reduce(
            (acc, item) => {
                acc.Quantity += parseAndFix(item.Quantity);
                acc.QuantityInPackets += parseAndFix(item.QuantityInPackets);
                acc.Amount += parseAndFix(item.Amount);
                acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                acc.TotalAmount += parseAndFix(item.TotalAmount);
                acc.CESSAmount += parseAndFix(item.CESSAmount);
                return acc;
            },
            { Quantity: 0, QuantityInPackets: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
        );
    };


    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Update the input field immediately
        const updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);

        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));

        if (['CashAmount', 'CardAmount', 'PaidAmount', 'Freight', 'PackingCharge'].includes(name)) {
            // Use the value directly for the calculation to avoid relying on stale state
            updateFormDataAndDetails(name, updatedValue);
        }
    };

    const updateFormDataAndDetails = (key, value) => {
        // const fixedValue = parseAndFix(value).toFixed(2);
        const fixedValue = parseAndFix(value);
        // Update the formData with the new value
        setFormData((prevData) => ({
            ...prevData,
            [key]: fixedValue,
            ModifiedBy: userId,
        }));

        // Use the updated value for calculations
        const updatedFormData = {
            ...formData,    // current form data
            [key]: fixedValue  // the newly updated value
        };

        // Recalculate invoice details using the latest form data
        const updatedItemData = invoicedeatils.map((item) => calculateItemData(item, updatedFormData));
        setInvoicedeatils(updatedItemData);

        // Calculate totals based on the updated invoice details
        const totals = calculateTotals(updatedItemData);

        // Dynamically get the values from the updated form data
        const dynamicValue = (key) => parseAndFix(updatedFormData[key] || 0);

        // Fetch the latest values for calculations
        const CashAmount = dynamicValue('CashAmount');
        const CardAmount = dynamicValue('CardAmount');
        const UPIAmount = dynamicValue('UPIAmount');
        const PaidAmount = dynamicValue('PaidAmount');
        const Freight = dynamicValue('Freight');
        const PackingCharge = dynamicValue('PackingCharge');

        // Perform the final total calculation
        totalCalculation(
            totals.Quantity,
            totals.QuantityInPackets,
            totals.Amount,
            totals.CGSTAmount,
            totals.SGSTAmount,
            totals.IGSTAmount,
            totals.TotalAmount,
            CashAmount,
            totals.DiscountAmount,
            CardAmount,
            UPIAmount,
            totals.TaxableAmount,
            totals.CESSAmount,
            PaidAmount,  // Ensure latest PaidAmount is used
            Freight,
            PackingCharge
        );
    };


    useEffect(() => {
        // This effect runs when formData is updated and specific fields need to be recalculated
        if (formData.CashDiscount || formData.CashAmount || formData.CardAmount || formData.UPIAmount) {
            const updateDetails = () => {
                const updatedItemData = invoicedeatils.map((item) => calculateItemData(item, formData));
                setInvoicedeatils(updatedItemData);

                const totals = updatedItemData.reduce(
                    (acc, item) => {
                        acc.Quantity += parseAndFix(item.Quantity);
                        acc.QuantityInPackets += parseAndFix(item.QuantityInPackets);
                        acc.Amount += parseAndFix(item.Amount);
                        acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                        acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                        acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                        acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                        acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                        acc.TotalAmount += parseAndFix(item.TotalAmount);
                        acc.CESSAmount += parseAndFix(item.CESSAmount);
                        return acc;
                    },
                    { Quantity: 0, QuantityInPackets: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
                );

                const DiscountAmount = parseAndFix(formData.DiscountAmount);
                const CashAmount = parseAndFix(formData.CashAmount);
                const CardAmount = parseAndFix(formData.CardAmount);
                const UPIAmount = parseAndFix(formData.UPIAmount);
                let PaidAmount = parseAndFix(formData.PaidAmount);
                let Freight = parseFloat(formData.Freight) || 0;
                let PackingCharge = parseFloat(formData.PackingCharge) || 0;

                totalCalculation(
                    totals.Quantity,
                    totals.QuantityInPackets,
                    totals.Amount,
                    totals.CGSTAmount,
                    totals.SGSTAmount,
                    totals.IGSTAmount,
                    totals.TotalAmount,
                    CashAmount,
                    totals.DiscountAmount,
                    CardAmount,
                    UPIAmount,
                    totals.TaxableAmount,
                    totals.CESSAmount,
                    PaidAmount,

                    Freight,
                    PackingCharge
                );
            };

            updateDetails();
        }
    }, [formData.CashDiscount, formData.CashAmount, formData.CardAmount, formData.UPIAmount]);


    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.CustomerName) {
            setErrorMessage('Customer Name is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.BillNumber) {
            setErrorMessage('Bill Number is required !');
            setIsLoading(false);
            return;
        }

        // Cash amount validation
        if (formData.BlanceAmount < 0) {
            setErrorMessage('Blance Amount less than 0 is not allowed!');
            setIsLoading(false);
            return;
        }

        // Validate quantity against available stock
        const invalidItems = invoicedeatils.filter(invdetail => {
            return (
                (invdetail.StockFromBranchId === 1 && invdetail.Quantity > invdetail.PBVRStock) ||
                (invdetail.StockFromBranchId === 2 && invdetail.Quantity > invdetail.CHERIStock)
            );
        });

        if (invalidItems.length > 0) {
            setErrorMessage('Quantity cannot exceed available stock for some items!');
            setIsLoading(false);
            return;
        }

        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: invoicedeatils
        };

        // Validate form data here if needed

        postData('SaleReturnApi', CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                const SaleId = response.kotId;
                handlePrint(SaleId);
                history.push('/SaleReturnIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const handlePrint = async (saleid) => {
        try {

            const response = await fetchData('SaleReturnApi', `/SalePrint/${saleid}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...invoicedeatils];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record 

            const updatedItemData = updatedRecords.map((item) => calculateItemData(item, formData));           

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.QuantityInPackets += parseAndFix(item.QuantityInPackets);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    acc.CESSAmount += parseAndFix(item.CESSAmount);
                    return acc;
                },
                { Quantity: 0, QuantityInPackets: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
            );



            const DiscountAmount = parseAndFix(formData.DiscountAmount);
            const CashAmount = parseAndFix(formData.CashAmount);
            const CardAmount = parseAndFix(formData.CardAmount);
            const UPIAmount = parseAndFix(formData.UPIAmount);
            let PaidAmount = parseAndFix(formData.PaidAmount);

            let Freight = parseFloat(formData.Freight) || 0;
            let PackingCharge = parseFloat(formData.PackingCharge) || 0;            

            totalCalculation(
                totals.Quantity,
                totals.QuantityInPackets,
                totals.Amount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                CashAmount,
                DiscountAmount,
                CardAmount,
                UPIAmount,     
                totals.TaxableAmount,         
                totals.CESSAmount,
                PaidAmount,
                Freight,
                PackingCharge
            );

        }

    };

    //Items    
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState("");

    // FOR MODEL DATA (Invoice Details)
    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemId: '',
        Quantity: '',
        QuantityInPackets: '',
        Rate: '',
        Amount: '',
        GSTRate: '',
        GSTAmount: '',
        TotalAmount: '',
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemId: '',
            Quantity: '',
            QuantityInPackets: '',
            Rate: '',
            Amount: '',
            GSTRate: '',
            GSTAmount: '',
            TotalAmount: '',
        });
        setSelectedItem();
        setIsModalOpen(false);
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }



        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setInvoicedeatils(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName1: '',
                ItemId: '',
                // Quantity: '1',
                Quantity: '',
                QuantityInPackets: '',
                Rate: '',
                Amount: '',
                GSTRate: '',
                GSTAmount: '',
                TotalAmount: '',
            });

            setSelectedItemOption(null); // Clear AsyncSelect
            fetchItemOptions('');
            //closeModal();

            //Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const QuantityInPackets = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.QuantityInPackets), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const CESSAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CESSAmount), 0);



            let CashAmount = parseFloat(formData.CashAmount) || 0;
            let CardAmount = parseFloat(formData.CardAmount) || 0;
            let UPIAmount = parseFloat(formData.UPIAmount) || 0;
            let PaidAmount = parseAndFix(formData.PaidAmount);

            let Freight = parseFloat(formData.Freight) || 0;
            let PackingCharge = parseFloat(formData.PackingCharge) || 0;

            totalCalculation(Quantity, QuantityInPackets, Amount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, CashAmount, DiscountAmount, CardAmount, UPIAmount, TaxableAmount, CESSAmount, PaidAmount, Freight, PackingCharge);


        } else {

            console.log("Validation errors:", errors);
            setErrorMessageModel(errors);
        }

    };

    const totalCalculation = (
        Quantity,
        QuantityInPackets,
        Amount,
        CGSTAmount,
        SGSTAmount,
        IGSTAmount,
        TotalAmount,
        CashAmount,
        DiscountAmount,
        CardAmount,
        UPIAmount,
        TaxableAmount,
        CESSAmount,
        PaidAmount,
        Freight,
        PackingCharge
    ) => {
        // Use QuantityInPackets if greater than 0, otherwise fallback to Quantity
        const effectiveQuantity = QuantityInPackets > 0 ? QuantityInPackets : Quantity;

        let netAmt =
            TaxableAmount +
            parseFloat(CGSTAmount) +
            parseFloat(SGSTAmount) +
            parseFloat(IGSTAmount) +
            parseFloat(CESSAmount) +
            parseFloat(Freight) +
            parseFloat(PackingCharge);

        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmt = parseFloat(netAmt + roundOffValue).toFixed(2);

        let balhamt = parseFloat(totalAmt - PaidAmount).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            // TotalQuantity: effectiveQuantity, 
            TotalQuantity: Quantity + QuantityInPackets,
            TotalAmount: Amount.toFixed(2),
            DiscountAmount: parseFloat(DiscountAmount).toFixed(2),
            TaxableAmount: parseFloat(TaxableAmount).toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            CESSAmount: CESSAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            GrandTotal: totalAmt,
            BalanceAmount: balhamt,
            ModifiedBy: userId,
        }));
    };

    const [itemdetails, setItemDetails] = useState([]);
    const [customerdetails, setCustomerDetails] = useState([]);

    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setModalData({
            ...modalData,
            [name]: value,
        });

        if (name === 'Quantity') {

            const quantity = parseFloat(value) || 0;
            const packetQuantity = modalData.QuantityInPackets;
            const rate = modalData.Rate;
            const cgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const sgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            let gstrate = (cgstrate + sgstrate).toFixed(2);
            let cessrate = parseAndFix(modalData.CESSRate);
            const amount = (quantity * (rate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100))).toFixed(2);

            let Discper = parseFloat(modalData.DiscountPercentage) || 0;
            let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
            let totdiscount = parseFloat(Addidiscamt);
            let grate = (rate - totdiscount).toFixed(2);
            let salerate = (grate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);

            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            if (formData.InvoiceTypeId == 3) {
                igstamt = ((taxableamount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((taxableamount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((taxableamount * (sgstrate)) / 100).toFixed(2);
            }
            let cessamt = ((taxableamount * (cessrate)) / 100).toFixed(2);
            let gstamt = (parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);
            const totalAmount = (parseFloat(taxableamount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt) + parseAndFix(cessamt)).toFixed(2);

            setModalData({
                ...modalData,
                Rate: rate, // Assuming Rate is a number           
                Quantity: quantity,
                QuantityInPackets: packetQuantity,
                Amount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                CESSRate: cessrate,
                CESSAmount: cessamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
                DiscountPercentage: Discper,
                DiscountAmount: totdiscount * quantity,
                TaxableAmount: taxableamount,
            });
        }
        if (name === 'QuantityInPackets') {

            const packetQuantity = parseFloat(value) || 0;
            const quantity = modalData.Quantity;
            const rate = modalData.Rate;
            const cgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const sgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            let gstrate = (cgstrate + sgstrate).toFixed(2);
            let cessrate = parseAndFix(modalData.CESSRate);
            const amount = (packetQuantity * (rate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100))).toFixed(2);

            let Discper = parseFloat(modalData.DiscountPercentage) || 0;
            let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
            let totdiscount = parseFloat(Addidiscamt);
            let grate = (rate - totdiscount).toFixed(2);
            let salerate = (grate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100)).toFixed(2);
            const taxableamount = (packetQuantity * salerate).toFixed(2);

            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            if (formData.InvoiceTypeId == 3) {
                igstamt = ((taxableamount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((taxableamount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((taxableamount * (sgstrate)) / 100).toFixed(2);
            }
            let cessamt = ((taxableamount * (cessrate)) / 100).toFixed(2);
            let gstamt = (parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);
            const totalAmount = (parseFloat(taxableamount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt) + parseAndFix(cessamt)).toFixed(2);

            setModalData({
                ...modalData,
                Rate: rate,
                Quantity: quantity,
                QuantityInPackets: packetQuantity,
                Amount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                CESSRate: cessrate,
                CESSAmount: cessamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
                DiscountPercentage: Discper,
                DiscountAmount: totdiscount * quantity,
                TaxableAmount: taxableamount,
            });
        }
        else if (name === 'Rate') {
            const quantity = parseFloat(modalData.Quantity) || 0;
            const packetQuantity = parseFloat(modalData.QuantityInPackets) || 0;
            const effectiveQuantity = packetQuantity > 0 ? packetQuantity : quantity; // Use packetQuantity if greater than 0, else fallback to quantity
            // const rate = parseFloat(value) || 0;
            const rate = value;
            const cgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const sgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const gstrate = (cgstrate + sgstrate).toFixed(2);
            const cessrate = parseAndFix(modalData.CESSRate);

            const amount = (effectiveQuantity * (rate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100))).toFixed(2);
            const discPer = parseFloat(modalData.DiscountPercentage) || 0;
            const additionalDiscAmount = ((rate * discPer) / 100).toFixed(2);
            const totalDiscount = parseFloat(additionalDiscAmount);
            const grossRate = (rate - totalDiscount).toFixed(2);
            const saleRate = (grossRate / (1 + (parseFloat(gstrate) + parseFloat(cessrate)) / 100)).toFixed(2);
            const taxableAmount = (effectiveQuantity * saleRate).toFixed(2);

            let cgstAmount = 0;
            let sgstAmount = 0;
            let igstAmount = 0;

            if (formData.InvoiceTypeId == 3) {
                igstAmount = ((taxableAmount * (cgstrate + sgstrate)) / 100).toFixed(2);
            } else {
                cgstAmount = ((taxableAmount * cgstrate) / 100).toFixed(2);
                sgstAmount = ((taxableAmount * sgstrate) / 100).toFixed(2);
            }

            const cessAmount = ((taxableAmount * cessrate) / 100).toFixed(2);
            const gstAmount = (parseFloat(cgstAmount) + parseFloat(sgstAmount) + parseFloat(igstAmount)).toFixed(2);
            const totalAmount = (parseFloat(taxableAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount) + parseFloat(igstAmount) + parseAndFix(cessAmount)).toFixed(2);

            setModalData({
                ...modalData,
                Rate: rate,
                Amount: amount,
                CGSTAmount: cgstAmount,
                SGSTAmount: sgstAmount,
                IGSTAmount: igstAmount,
                CESSRate: cessrate,
                CESSAmount: cessAmount,
                TotalAmount: totalAmount,
                GSTAmt: gstAmount,
                DiscountPercentage: discPer,
                DiscountAmount: totalDiscount * effectiveQuantity,
                TaxableAmount: taxableAmount,
            });
        }

    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = inputType;
            value = e;
        }

        setInvoicedeatils((prevDetails) => {
            const newDetails = [...prevDetails];
            newDetails[index] = {
                ...newDetails[index],
                [name]: value,
            };

            const updatedItemData = newDetails.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.QuantityInPackets += parseAndFix(item.QuantityInPackets);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    acc.CESSAmount += parseAndFix(item.CESSAmount);
                    return acc;
                },
                { Quantity: 0, QuantityInPackets: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
            );

            const DiscountAmount = parseAndFix(formData.DiscountAmount);
            const CashAmount = parseAndFix(formData.CashAmount);
            const CardAmount = parseAndFix(formData.CardAmount);
            const UPIAmount = parseAndFix(formData.UPIAmount);
            const PaidAmount = parseAndFix(formData.PaidAmount);
            let Freight = parseFloat(formData.Freight) || 0;
            let PackingCharge = parseFloat(formData.PackingCharge) || 0;

            totalCalculation(
                totals.Quantity,
                totals.QuantityInPackets,
                totals.Amount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                CashAmount,
                totals.DiscountAmount,
                CardAmount,
                UPIAmount,
                totals.TaxableAmount,
                totals.CESSAmount,
                PaidAmount,
                Freight,
                PackingCharge
            );

            return updatedItemData;
        });
    };

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownBankOptions();
    }, []);

    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleReturnApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const fetchDropdownBankOptions = () => {
        fetchData('SaleReturnApi', `/Bank/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownBankOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Bank dropdown options:', error);
            });
    };

    const handleGSTNumberChange = (e) => {
        const gstNumber = e.target.value;
        let newInvoiceTypeId;
        if (!gstNumber) {
            newInvoiceTypeId = 2;
            setSelectedInvoiceType({ value: 2, label: 'B To C' });
        } else {
            const gstNumberPrefix = gstNumber.substring(0, 2);
            newInvoiceTypeId = (gstNumberPrefix !== branchstate) ? 3 : 1;
            setSelectedInvoiceType({
                value: newInvoiceTypeId,
                label: newInvoiceTypeId === 3 ? 'IGST' : 'B To B'
            });
        }

        setFormData(prevData => ({
            ...prevData,
            GSTNumber: gstNumber,
            InvoiceTypeId: newInvoiceTypeId,
        }));

        fetchmaxbillno(newInvoiceTypeId);
    };

    const handleBranchChange = (e, index) => {
        const newInvoiceDetails = [...invoicedeatils];
        newInvoiceDetails[index].StockFromBranchId = e.target.value;
        setInvoicedeatils(newInvoiceDetails);
    };

    const checkStockLevels = (item) => {
        if (item.StockFromBranchId === "1") {
            return item.Quantity > item.PBVRStock;
        } else if (item.StockFromBranchId === "2") {
            return item.Quantity > item.CHERIStock;
        }
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Sale Return - Create</h6>

                    <Button
                        variant="contained"
                        style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to="/SaleReturnIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px' }}
                    >
                        CANCEL
                    </Button>

                </div>


                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex" style={{ marginTop: '-0.45%' }}>
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '500px', overflowY: 'auto', width: '100%' }}>

                        <div className="w-full mb-2 flex" style={{ marginTop: '-1%' }}>
                            <div className="w-2/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Customer
                                    <span className="text-red-500">*</span>
                                </label>
                                <AsyncCreatableSelect
                                    cacheOptions
                                    loadOptions={fetchOptions}
                                    onInputChange={handleInputChange}
                                    onChange={handleCustomerSelect}
                                    value={selectedOption}
                                    placeholder="Type or select a customer"
                                    formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                    isClearable
                                    onCreateOption={(inputValue) => {
                                        const newOption = { value: inputValue, label: inputValue };
                                        setSupplierOptions([...supplierOptions, newOption]);
                                        setSelectedOption(newOption);
                                        setFormData((prevData) => ({
                                            ...prevData,
                                            CustomerId: 0,
                                            CreatedBy: userId,
                                            CustomerName: inputValue,
                                            CustomerAddress: '',
                                            GSTNumber: '',
                                            ContactNumber: '',
                                        }));
                                        const newInvoiceTypeId = 2;
                                        setSelectedInvoiceType({
                                            value: 2,
                                            label: 'B To C'
                                        });
                                        fetchmaxbillno(newInvoiceTypeId);
                                    }}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            height: '30px',
                                            minHeight: '30px',
                                            fontSize: '14px',
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                        }),
                                    }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Invoice Type
                                    <span className="text-red-500">*</span>
                                </label>

                                <select
                                    className={`custom-select ${selectedInvoiceType ? 'fade-in' : 'fade-in'}`}
                                    value={selectedInvoiceType.value}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedInvoiceType(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            InvoiceTypeId: selectedValue,
                                        }));
                                    }}
                                    disabled
                                    style={{
                                        height: '30px', // Set the desired height
                                        fontSize: '14px', // Adjust font size if needed
                                        padding: '5px', // Add padding for better appearance
                                    }}
                                >
                                    <option value="">Invoice Type</option>
                                    {dropdownInvoiceTypeOptions.map((category) => (
                                        <option key={category.Id} value={category.Id}>
                                            {category.Name}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Bill Date
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formatDateForInput(formData.BillDate)}
                                    onChange={handleChange}
                                    type="date"
                                    name='BillDate'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Bill No
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={`${formData.BillPrefix || ''}${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="BILL NUMBER"
                                    name='BillNumber'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Sales Man
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    className={`custom-select ${selectedSalesMan ? 'fade-in' : 'fade-in'}`}
                                    value={selectedSalesMan}
                                    // onChange={(e) => setSelectedSalesMan(e.target.value)}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedSalesMan(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            ExecutiveId: selectedValue,
                                        }));
                                    }}
                                    style={{
                                        height: '30px', // Adjust height of the select box
                                        minHeight: '30px',
                                        fontSize: '14px', // Adjust font size
                                        border: '1px solid #ccc', // Optional styling for the border
                                        borderRadius: '4px', // Optional styling for rounded corners
                                        padding: '5px', // Optional padding for better appearance
                                    }}

                                >
                                    <option value="">Sales Man</option>
                                    {dropdownSalesManOptions.map((category) => (
                                        <option key={category.Id} value={category.Id}>
                                            {category.Name}
                                        </option>
                                    ))}
                                </select>

                            </div>


                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Address
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CustomerAddress}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="ADDRESS"
                                    name='CustomerAddress'
                                />
                            </div>

                            <div className="w-2/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    GST Number
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.GSTNumber}
                                    maxLength={15}
                                    onChange={handleGSTNumberChange}
                                    type="text"
                                    placeholder="GST NUMBER"
                                    name='GSTNumber'
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Phone No
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.ContactNumber}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="PHONE NUMBER"
                                    name='ContactNumber'
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total Qty
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TotalQuantity}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="TOTAL QUANTITY"
                                    name='TotalQuantity'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Sale Bill Date
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formatDateForInput(formData.SaleBillDate)}
                                    onChange={handleChange}
                                    type="date"
                                    name='SaleBillDate'

                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Sale Bill No
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={`${formData.SaleBillNumber || ''}`}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="BILL NUMBER"
                                    name='SaleBillNumber'
                                />
                            </div>

                        </div>
                        
                        <div className="w-full pr-4" style={{ marginTop: '-1%' }}>
                            {errorMessageModel && <p className="text-red-500">{errorMessageModel}</p>}
                            <div className="w-full mb-2 flex">
                                <div className="w-full mr-3">
                                    <label className="block uppercase tracking-wide text-xs font-bold mb-2" htmlFor="Weightage">
                                        Item Name
                                    </label>
                                    <AsyncSelect
                                        cacheOptions
                                        loadOptions={fetchItemOptions}
                                        onInputChange={handleItemChange}
                                        onChange={handleChangeDrop}
                                        value={selectedItemOption}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                height: '30px',
                                                minHeight: '30px',
                                                fontSize: '14px',
                                            }),
                                            input: (base) => ({
                                                ...base,
                                                fontSize: '14px',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: '14px',
                                            }),
                                        }}
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-xs font-bold mb-2" htmlFor="Quantity">
                                        Quantity
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                        type="text"
                                        name="Quantity"
                                        placeholder="Quantity"
                                        value={modalData.Quantity}
                                        onChange={(e) => {
                                            handleModalInputChange(e);
                                            // Disable Packet Quantity if Quantity is greater than 0
                                            if (parseFloat(e.target.value) > 0) {
                                                setModalData((prev) => ({
                                                    ...prev,
                                                    QuantityInPackets: "0",
                                                }));
                                            }
                                        }}
                                        disabled={modalData.QuantityInPackets > 0}
                                        styles={{ maxHeight: '25px' }}
                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-xs font-bold mb-2" htmlFor="QuantityInPackets">
                                        Packet Quantity
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                        type="text"
                                        name="QuantityInPackets"
                                        placeholder="QuantityInPackets"
                                        value={modalData.QuantityInPackets}
                                        onChange={(e) => {
                                            handleModalInputChange(e);
                                            // Disable Quantity if Packet Quantity is entered
                                            if (parseFloat(e.target.value) > 0) {
                                                setModalData((prev) => ({
                                                    ...prev,
                                                    Quantity: "0",
                                                }));
                                            }
                                        }}
                                        disabled={modalData.Quantity > 0}
                                        styles={{ maxHeight: '20px' }}
                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-xs font-bold mb-2" htmlFor="Rate">
                                        Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                        type="text"
                                        name="Rate"
                                        placeholder="Rate"
                                        value={modalData.Rate}
                                        onChange={handleModalInputChange}
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <button
                                        className="bg-green-500 px-4 py-2 rounded"
                                        onClick={saveModalData}
                                        style={{ marginLeft: '6px', marginTop: '25px', color: 'white', maxHeight: '35px' }}
                                    >
                                        <span style={{ marginTop: '-2px' }}>Add</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="w-full mb-2 flex">
                            <div className="w-full mb-2 flex">
                                <TableContainer component={Paper}>
                                    <table className="table">
                                        <thead>
                                            <tr style={{ backgroundColor: '#CDE69A' }}>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A' }}>Item Name</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'center', fontSize: '14px' }}>Qty</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'center', fontSize: '14px' }}>Qty (P)</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'center', fontSize: '14px' }}>Rate</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'center', fontSize: '14px' }}>Amount</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'center', fontSize: '14px' }}>Disc %</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'center', fontSize: '14px' }}>Discount</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'center', fontSize: '14px' }}>Total</th>
                                                <th style={{ padding: '4px', backgroundColor: '#CDE69A', textAlign: 'right', fontSize: '14px' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicedeatils.map((invdetail, index) => {
                                                const isStockExceeded = checkStockLevels(invdetail);
                                                return (
                                                    <tr key={index} style={{ width: '100%', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                        <td style={{ padding: '2px', fontSize: '14px', width: '35%', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <label style={{ marginTop: '9px', color: 'black' }}>
                                                                {invdetail.ItemName}
                                                            </label>
                                                        </td>
                                                        <td style={{ padding: '2px', fontSize: '14px', width: '8%', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <input
                                                                type="number"
                                                                value={invdetail.Quantity}
                                                                onChange={(e) => {
                                                                    const value = Number(e.target.value);
                                                                    handleCalculation(e, index, 'Quantity');
                                                                    // Automatically update QuantityInPackets
                                                                    if (value > 0) {
                                                                        const updatedDetails = [...invoicedeatils];
                                                                        updatedDetails[index].QuantityInPackets = 0;
                                                                        handleCalculation({ target: { value: 0 } }, index, 'QuantityInPackets');
                                                                    }
                                                                }}
                                                                disabled={invdetail.QuantityInPackets > 0}
                                                                style={{ textAlign: 'right', padding: '5px' }}
                                                                name="Quantity"
                                                                min={0}
                                                            />
                                                        </td>
                                                        <td style={{ padding: '2px', fontSize: '14px', width: '8%', textAlign: 'center', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <input
                                                                type="number"
                                                                value={invdetail.QuantityInPackets}
                                                                onChange={(e) => {
                                                                    const value = Number(e.target.value);
                                                                    handleCalculation(e, index, 'QuantityInPackets');
                                                                    // Automatically update Quantity
                                                                    if (value > 0) {
                                                                        const updatedDetails = [...invoicedeatils];
                                                                        updatedDetails[index].Quantity = 0;
                                                                        handleCalculation({ target: { value: 0 } }, index, 'Quantity');
                                                                    }
                                                                }}
                                                                disabled={invdetail.Quantity > 0}
                                                                style={{ textAlign: 'right', padding: '5px' }}
                                                                name="QuantityInPackets"
                                                                min={0}
                                                            />
                                                        </td>
                                                        <td style={{ padding: '2px', fontSize: '14px', width: '8%', textAlign: 'center', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <input
                                                                type="number"
                                                                value={invdetail.Rate}
                                                                onChange={(e) => handleCalculation(e, index, 'Rate')}
                                                                style={{ textAlign: 'right', padding: '5px' }}
                                                                name="Rate"
                                                                min={0}
                                                            />
                                                        </td>
                                                        <td style={{ padding: '2px', fontSize: '14px', width: '8%', textAlign: 'right', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <input
                                                                type="text"
                                                                value={invdetail.Amount}
                                                                style={{ textAlign: 'right', padding: '5px' }}
                                                                name="Amount"
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td style={{ padding: '2px', fontSize: '14px', width: '5%', textAlign: 'center', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <input
                                                                type="number"
                                                                value={invdetail.DiscountPercentage}
                                                                onChange={(e) => handleCalculation(e, index, 'Quantity')}
                                                                style={{ maxWidth: '90px', textAlign: 'right', padding: '5px' }}
                                                                name="DiscountPercentage"
                                                            />
                                                        </td>
                                                        <td style={{ padding: '2px', fontSize: '14px', width: '8%', textAlign: 'right', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <input
                                                                type="text"
                                                                value={invdetail.DiscountAmount}
                                                                style={{ maxWidth: '90px', textAlign: 'right', padding: '5px' }}
                                                                name="DiscountAmount"
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td style={{ padding: '2px', fontSize: '14px', width: '8%', textAlign: 'right', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <input
                                                                type="text"
                                                                value={invdetail.TotalAmount}
                                                                style={{ maxWidth: '90px', textAlign: 'right', padding: '5px' }}
                                                                name="TotalAmount"
                                                                readOnly
                                                            />
                                                        </td>
                                                        <td style={{ padding: '2px', marginTop: '-15px', width: '5%', textAlign: 'right', backgroundColor: isStockExceeded ? '#FF7F7F' : 'white' }}>
                                                            <IconButton style={{ padding: '8px' }} onClick={() => removeRecord(index)}>
                                                                <DeleteIcon style={{ color: 'red' }} />
                                                            </IconButton>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>

                                    </table>
                                </TableContainer>

                            </div>
                        </div>

                        <div className="w-full mb-2 flex">

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.Remarks}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="REMARKS"
                                    name='Remarks'
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TotalAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="AMOUNT"
                                    style={{ textAlign: 'right' }}
                                    name='TotalAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Discount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.DiscountAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="DISCOUNT"
                                    style={{ textAlign: 'right' }}
                                    name='DiscountAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Net Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TaxableAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="NET AMOUNT"
                                    name='TaxableAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    CESS
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CESSAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CESSAmount"
                                    name='CESSAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    IGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.IGSTAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="IGST"
                                    name='IGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                        </div>

                        <div className="w-full mb-2 flex">
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    CGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CGSTAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CGST"
                                    name='CGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    SGST
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.SGSTAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="SGST"
                                    name='SGSTAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Freight
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.Freight}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="Freight"
                                    name='Freight'
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Packing
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.PackingCharge}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="Packing Charge"
                                    name='PackingCharge'
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Round Off
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.RoundOff}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="ROUND OFF"
                                    name='RoundOff'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.GrandTotal}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="GRAND TOTAL"
                                    name='GrandTotal'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Paid Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8 ${formData.CashAmount < 0 ? 'text-red-500' : ''}`}
                                    value={formData.PaidAmount}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="PaidAmount"
                                    name='PaidAmount'
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Balance
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.BalanceAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Balance"
                                    name='BalanceAmount'
                                    style={{
                                        textAlign: 'right',
                                        color: formData.BalanceAmount < 0 ? 'red' : 'black' // Changes color based on BalanceAmount
                                    }}
                                />
                            </div>

                        </div>

                        <div className="w-full mb-2 flex">
                            {(formData.CardAmount > 0 || formData.UPIAmount > 0) && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="bank">
                                        Bank
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedBank ? 'fade-in' : 'fade-in'}`}
                                        value={selectedBank}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedBank(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                BankId: selectedValue,
                                            }));
                                        }}
                                    >
                                        <option value="">Bank</option>
                                        {dropdownBankOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}

                        </div>

                    </div>

                </div>

            </div >
        </Fragment >

    );
};

export default SaleReturnCreate;